var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.667 8c0-3.667-3-6.667-6.667-6.667S1.333 4.333 1.333 8s3 6.667 6.667 6.667 6.667-3 6.667-6.667z",
    stroke: "#A39CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.127 10.494c.343 0 .622.283.622.633 0 .349-.279.632-.622.632a.627.627 0 01-.622-.632c0-.35.278-.633.622-.633zm.833-6.319c.658.265 1.156.8 1.305 1.457.134.595.07 1.117-.186 1.567-.196.346-.488.628-.894.901l-.03.02-.028.019a6.08 6.08 0 01-.03.019l-.014.009c-.173.11-.287.224-.358.342l-.008.013-.007.013-.006.011-.006.01a.434.434 0 00-.002.006l-.006.01a.72.72 0 00-.007.017l-.005.01-.005.011-.004.011a.67.67 0 00-.004.011l-.004.011-.006.017h0l-.003.011-.004.012a.72.72 0 00-.007.03l-.003.012-.003.012-.002.013-.002.013-.003.017-.003.017-.002.02-.002.015-.001.015-.002.015v.016l-.002.024-.001.016-.001.017-.001.026v.018l-.002.028V9.12c0 .276-.22.5-.492.5a.496.496 0 01-.491-.492v-.155l.001-.03v-.02l.001-.02.004-.071.003-.035V8.78l.002-.017.002-.017.001-.008.006-.051.003-.018.002-.017.004-.027c.037-.226.11-.438.23-.639.151-.249.369-.468.659-.656l.014-.009c.683-.437.895-.81.747-1.464-.072-.317-.336-.601-.709-.75a1.412 1.412 0 00-1.226.075c-.546.309-.765.699-.716 1.246l.002.016a.498.498 0 01-.44.548.494.494 0 01-.538-.447c-.096-.965.33-1.737 1.215-2.237a2.378 2.378 0 012.065-.132z",
    stroke: "#655AEC",
    strokeWidth: 0.2,
    fill: "#655AEC",
    fillRule: "nonzero"
  }))));
}

export default SvgIcQuestion;